export const SpecialRoomOffersCardsCarousel = (function () {
	let swiperInstance, pagination = null;
  let SELECTORS = null;

  function initSwiper() {
    const swiperWrapper = document.querySelector(SELECTORS.swiperWrapper);
    pagination = document.querySelector(SELECTORS.pagination);

    if (!swiperWrapper || !pagination) { 
      console.error('Required elements not found');
      return null;
    }    

    // Initialize Swiper
    const swiper = new Swiper(SELECTORS.swiper, {
      slidesPerView: 1,
      grid: {
        rows: 5,
      },
      spaceBetween: 0,
      pagination: {
        el: SELECTORS.pagination,
        clickable: true,
      },
    });

		swiperInstance = swiper;

    // Add event listeners to update button states when slides change
    swiper.on('slideChange', function () {
    });

    return swiper;
  }

  // Public methods
  return {
    init: function(selectors) {
      SELECTORS = selectors;
      document.addEventListener('DOMContentLoaded', function() {

        // Initialize swiper
        initSwiper();
      });
    }
  };
})();

